import script from "./adminHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./adminHeader.vue?vue&type=script&setup=true&lang=js"

import "./adminHeader.vue?vue&type=style&index=0&id=1b54b073&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b54b073"]])

export default __exports__